import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 720px;
`;

const TopButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
`;

export { PageContainer, ContentContainer, TopButtonsContainer };
